import { enqueueSnackbar } from 'notistack';

export interface OpenToastOptions {
  message: string;
  variant: 'success' | 'error' | 'warning';
  autoHideDuration?: number;
  horizontal?: 'left' | 'center' | undefined;
}
export function openToast(options: OpenToastOptions): void {
  enqueueSnackbar(options.message, {
    variant: options.variant,
    autoHideDuration: options.autoHideDuration || 3000,
    anchorOrigin: {
      horizontal: options.horizontal || 'left',
      vertical: 'top',
    },
  });
}
